"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RefreshRounded_1 = __importDefault(require("@mui/icons-material/RefreshRounded"));
const react_bootstrap_1 = require("react-bootstrap");
const clsx_1 = __importDefault(require("clsx"));
const ButtonSDS = ({ text, variant = 'default', icon, isLoading, isDisabled, className, onClick = () => {
    /**/
}, }) => (react_1.default.createElement(react_bootstrap_1.Button, { className: (0, clsx_1.default)('btn', icon && 'btn-icon', isLoading && 'btn-icon is-loading', !text && 'btn-icon-solo', className), disabled: isDisabled, onClick: onClick, variant: variant },
    isLoading ? react_1.default.createElement(RefreshRounded_1.default, { className: "icon" }) : icon && icon,
    text && react_1.default.createElement("span", null, text)));
exports.default = ButtonSDS;
